import { render } from "./TaskCardSimple.vue?vue&type=template&id=3243c4fd&scoped=true"
import script from "./TaskCardSimple.vue?vue&type=script&lang=js"
export * from "./TaskCardSimple.vue?vue&type=script&lang=js"

import "./TaskCardSimple.vue?vue&type=style&index=0&id=3243c4fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3243c4fd"]])

export default __exports__